<template>
  <div class="item" @click="goDetail" v-if="item">
    <div class="item-img" :style="{ backgroundImage: 'url(' + item.cover_img + ')' }">
      <img :src="item.cover_img" alt="" @error="imgError(item)">
      <div class="defaultRedBtnBox" v-if="item.award">
        <div class="defaultRed-btn">
          <div class="btn item-tips ellipsis">{{ item.award }}</div>
        </div>
      </div>
    </div>
    <div class="item-txt">
      <div class="item-title">
        <h3 class="ellipsis" :title="item.title">{{ item.title }}</h3>
      </div>
      <div class="item-sub">
        <span v-if="item.type_name">{{ item.type_name | formatShowFirst }}</span>
        <span class="flex-bd" v-if="item.produce_time">{{ item.produce_time | formatStandardDate }}</span>
        <label v-if="item.author">{{ item.author }}</label>
      </div>
      <p class="item-look" v-if="item.look_count">
        <em class="iconfont icon-attention"></em>
        <i>{{ item.look_count }}</i>
      </p>
    </div>
  </div>
</template>

<script>
import colums from '@/colums/colums.js'
export default {
  name: 'ExhibitItem',
  props: {
    item: Object
  },
  data() {
    return {
      colums: colums.exhibitCate
    }
  },
  mounted() {

  },
  methods: {
    goDetail() {
      const hash = this.$utils.hashNum(0)
      const path = `/exhibit/${this.item.id}/${hash}`
      try {
        let routeLink = this.$router.resolve({
          path
        })
        window.open(routeLink.href, "_blank")
      } catch (error) {
        this.$router.push({
          path
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.item {
  .item-img {
    background: #f3f3f3 center center no-repeat;
    background-size: cover;

    img {
      opacity: 0;
    }
  }

  .item-txt {
    display: block;
    .item-sub {
      span {
        line-height: 1.5;
        &.flex-bd {
          &::after {
            display: none;
          }
        }
      }
    }
  }
}</style>